import { useMemo } from 'react';
import { useBreakpoint } from '@frontend/responsiveness';
import { InsuranceReportHeaderDetails } from '../../../shared';
import { InsuranceReportPlanType } from '../../../types';
import { insuranceReportHeaderDetailsRowStyles } from '../../styles';
import { useDentalInsuranceReportContext } from '../context/DentalInsuranceReportDetailsContext.provider';
import { Vendors } from '../types/types';

type DentalInsuranceDetailsContainerProps = {
  isReportWriteback?: boolean;
  isPrintReport?: boolean;
};
export const DentalInsuranceDetailsContainer = ({
  isReportWriteback = false,
  isPrintReport = false,
}: DentalInsuranceDetailsContainerProps) => {
  const size = useBreakpoint();
  const isSmallOrMediumDevice = size === 'small' || size === 'medium';

  const {
    insuranceEligibilityReportData: {
      lastVerifiedAt,
      insuranceRequestDetails,
      dentalSummaryInfo: { patient, plan, payer, subscriber } = {},
      coverage = {},
    } = {},
    vendor,
  } = useDentalInsuranceReportContext();

  const planDetails = useMemo<InsuranceReportPlanType>(() => {
    return {
      effectiveDate: coverage?.effectiveDate,
      endDate: coverage?.endDate,
      groupName: plan?.groupName,
      groupNumber: plan?.groupNumber,
      name: plan?.planName,
      number: plan?.planNumber,
      type: plan?.type,
    };
  }, [coverage, plan]);

  const isRelationshipSelf = patient?.relationship?.toLowerCase() === 'self';

  return (
    <InsuranceReportHeaderDetails>
      <InsuranceReportHeaderDetails.InsuranceStatus
        lastVerifiedDate={lastVerifiedAt || ''}
        status={coverage?.status || ''}
        effectiveDate={coverage?.effectiveDate}
        endDate={coverage?.endDate}
        isReportWriteback={isReportWriteback}
      />
      <div css={[insuranceReportHeaderDetailsRowStyles(isSmallOrMediumDevice)]}>
        <InsuranceReportHeaderDetails.PayerDetails
          payerId={insuranceRequestDetails?.payerId || payer?.id || ''}
          payerName={insuranceRequestDetails?.payerName || payer?.name || ''}
        />
        <InsuranceReportHeaderDetails.PlanDetails
          plan={planDetails}
          memberId={insuranceRequestDetails?.memberId}
          groupName={insuranceRequestDetails?.groupName}
          groupNumber={insuranceRequestDetails?.groupNumber}
        />
      </div>
      <div css={[insuranceReportHeaderDetailsRowStyles(isSmallOrMediumDevice)]}>
        <InsuranceReportHeaderDetails.PatientDetails
          personDetails={patient || {}}
          relationship={patient?.relationship || insuranceRequestDetails?.relationship || ''}
        />
        {!isRelationshipSelf && (
          <InsuranceReportHeaderDetails.SubscriberDetails
            subscriberFirstName={subscriber?.firstName}
            subscriberLastName={subscriber?.lastName}
            subscriberDateOfBirth={
              subscriber?.dateOfBirth || subscriber?.dob || insuranceRequestDetails?.subscriberDateOfBirth
            }
            subscriberId={insuranceRequestDetails?.subscriberMemberId}
          />
        )}
      </div>
      {vendor === Vendors.TuuthFairy && (
        <div css={[insuranceReportHeaderDetailsRowStyles(isSmallOrMediumDevice)]}>
          <InsuranceReportHeaderDetails.Provisions provisions={plan?.provisions} isPrintReport={isPrintReport} />
          <InsuranceReportHeaderDetails.History service={plan?.services} isPrintReport={isPrintReport} />
        </div>
      )}
    </InsuranceReportHeaderDetails>
  );
};
